module.exports = __webpack_public_path__ + "static/media/no-track-assignment.667740a7.svg";